<template>
    <form @submit="submit">
        <div class="form-group row">
            <label for="txtMessage" class="col-sm-2 col-form-label">Message</label>
            <div class="col-sm-10">
                <input type="text" maxlength="280" class="form-control" id="txtMessage"
                    v-model="textToSpeechData.message">
                <small class="text-muted">280 characters max</small>
            </div>
        </div>
        <div class="form-group row">
            <label for="ddlVoice" class="col-sm-2 col-form-label">Voice</label>
            <div class="col-sm-10">
                <select class="form-control" id="ddlVoice" v-model="textToSpeechData.voice" disabled>
                    <option value="0">Select..</option>
                    <option value="slt">Sue (Female)</option>
                    <option value="kal">Kal (Male)</option>
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 col-form-label">Zone(s)</label>
            <div class="col-sm-10">
                <v-select multiple v-model="textToSpeechData.zones" :options="zones_for_drop_down"></v-select>
            </div>
        </div>
        <button type="button" class="btn btn-secondary" @click="callback && callback('cancel')">Close</button>
        <button type="submit" class="btn btn-hub-primary">Send</button>
    </form>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex';
import { ZONE_TYPE } from '../../assets/js/resource-types';

export default {
    props: {
        callback: Function
    },
    components: { vSelect },
    data() {
        return {
            textToSpeechData: {
                message: '',
                voice: 'kal',
                zones: []
            }
        }
    },
    computed: {
        ...mapGetters({
            zones: 'allZones',
            scoped_site_id: 'scopedSiteId',
        }),
        zones_for_drop_down() {
            return this.zones
                .filter(zone => zone.site_id === this.scoped_site_id && zone.zone_type_id !== ZONE_TYPE.Visual)
                .map(zone => ({ value: zone.zone_id, label: zone.name }));
        }
    },
    methods: {
        submit() {
            this.$store.dispatch('executeTts', this.textToSpeechData)
                .then(() => {
                    if(this.callback) 
                        this.callback('success');
                }).catch(() => {
                    if(this.callback) 
                        this.callback('failure');
                });
        }
    },
    created() {
        this.$store.dispatch('getZones');
    }
}
</script>